import { Component, OnInit } from '@angular/core';
import { drawDOM, exportPDF, Group } from '@progress/kendo-drawing';
import * as saveAs from 'file-saver';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { LegendLabelsContentArgs, SeriesLabelsVisualArgs } from '@progress/kendo-angular-charts';
import { IntlService } from '@progress/kendo-angular-intl';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-stroke-alert-cases',
  templateUrl: './stroke-alert-cases.component.html',
  styleUrls: ['./stroke-alert-cases.component.scss'],
})
export class StrokeAlertCasesComponent implements OnInit {

  public pieData: any = [];
  strokeAlertCases: any;
  totalRecords = 0;
  rows = 15;
  cols: any;
  piChartBool: boolean = false;
  TotaAllCases: any;
  chart: any;
  maxDate: any;
  minDate: any;
  showProgressSpinner:boolean = false;
  UId: any;
  RoleName: any;
  loader: any;
  isAscending: boolean = false;
  private subscription: Subscription[] = [];
  checkPiChartBool: boolean = false;
  field:any;
  fac_go_live: any;
  datePipe = new DatePipe('en-US');
  strokeAlertCasesCharts: any;
  dateConvertLive: any;
  
  constructor(public analyzeService: AnalyzeService, private intl: IntlService,private helperService: HelperService) {
    this.labelContent = this.labelContent.bind(this);
}
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.StrokeAlertCasesComponent = this;
    if ((this.analyzeService._facilityPiRecord.StrokeAlertCasesRecord != null) && (this.analyzeService._facilityPiRecord.StrokeAlertCasesRecord != undefined)) {
      this.strokeAlertCases = this.analyzeService._facilityPiRecord.StrokeAlertCasesRecord;
    }
      if(this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj != undefined){
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
      }
  }
 
  GetStrokeAlertCases(excel_chartDisabe: any,loader: any) {
    this.showProgressSpinner = true;
    this.subscription.push(
    this.analyzeService.GetStrokeAlertCases(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj).subscribe({
      next: (res: any) => {
        this.fac_go_live = res.fac_go_live;
        this.showProgressSpinner = false;
        this.strokeAlertCases = res.data;
        this.minDate = this.strokeAlertCases[0].date;
        this.maxDate = this.strokeAlertCases[this.strokeAlertCases.length - 1].date;
        this.analyzeService._facilityPiRecord.StrokeAlertCasesRecord = this.strokeAlertCases;
        this.totalRecords = res.Total;
        this.analyzeService.currentDateTime();
        loader.value = false;
        excel_chartDisabe.value = false;
      },
    })
    );
  }

  getPiChart(pi_chartBool: any){

    this.piChartBool = true;
    let EMS = 0;
    let Triage = 0;
    let Inpatient = 0
    let EdOnset = 0;
    let AudioConsult = 0;
    let SameCart = 0;
    let fac_go_live: any;

let fromMonth: any;
let toMonth: any;
if(this.fac_go_live){
  fac_go_live = new Date(this.fac_go_live);

fromMonth = new Date(this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj.data.fromMonth);
toMonth = new Date(this.analyzeService._facilityPiFilterObj.StrokeAlertCasesDataObj.data.toMonth);

if(  (
  (fromMonth.getFullYear() === fac_go_live.getFullYear() &&
  fromMonth.getMonth() < fac_go_live.getMonth()) ||
  (fromMonth.getFullYear() < fac_go_live.getFullYear())
) &&
(
  (toMonth.getFullYear() === fac_go_live.getFullYear() &&
  toMonth.getMonth() >= fac_go_live.getMonth()) ||
  (toMonth.getFullYear() > fac_go_live.getFullYear())
)){

  let dateConvert = this.datePipe.transform(fac_go_live,'MMMM y');
  let index = this.strokeAlertCases.findIndex((x: any) =>x.date ===  dateConvert);
  if(index !== -1){
    this.strokeAlertCasesCharts = this.strokeAlertCases.slice(index);
  }else{
  this.strokeAlertCasesCharts = this.strokeAlertCases;
  }

}else if((toMonth.getFullYear() < fac_go_live.getFullYear() || toMonth.getFullYear() === fac_go_live.getFullYear()) &&
        toMonth.getMonth() < fac_go_live.getMonth()){
          this.strokeAlertCasesCharts = [];
  this.dateConvertLive = this.datePipe.transform(fromMonth,'MMMM y');
  this.checkPiChartBool = true;

}else{
  this.strokeAlertCasesCharts = this.strokeAlertCases;
}
}else{
  this.strokeAlertCasesCharts = this.strokeAlertCases;
}

if(this.strokeAlertCasesCharts.length > 0){
    this.strokeAlertCasesCharts.forEach((element: any) => {
      EMS += element.EMS;
      Triage += element.Triage;
      Inpatient += element.Inpatient;
      EdOnset += element.EDOnset;
      AudioConsult += element.AudioConsult;
      SameCart += element.SameCart;
    });
    this.TotaAllCases = EMS + Triage + Inpatient + EdOnset + AudioConsult + SameCart;
    this.pieData = [
      { category: 'EMS', value: EMS, colorField:"#ed1878" },
      { category: 'Triage', value: Triage, colorField:"#00164c" },
      { category: 'Inpatient', value: Inpatient, colorField:"#9f1f60" },
      { category: 'ED Onset', value: EdOnset, colorField:"#653193" },
      { category: 'Audio Consult', value: AudioConsult, colorField:"#00aeef" },
      { category: 'Stroke on Same Cart', value: SameCart, colorField:"#808080" },
    ];
    let val:any;
      this.dateConvertLive = this.strokeAlertCasesCharts[0].date; 
      val= this.strokeAlertCasesCharts.every((val:any) => {
        return val.EMS === 0 && val.Triage === 0 && val.Inpatient === 0 && val.EDOnset === 0 && val.AudioConsult === 0 && val.SameCart === 0
      });

      if(val){
        this.checkPiChartBool = true;
      }else{
        this.checkPiChartBool = false;
      }
  }else{
    this.checkPiChartBool = true;
  }
      pi_chartBool.value = false;
  }

  public labelContent(args: LegendLabelsContentArgs): string {
    const result = args.dataItem.category + ": \n" + args.dataItem.value;
    return result;
  }

  visualContent = (e: SeriesLabelsVisualArgs) => {
    try {
      const defaultLabel: any = e.createVisual();
      defaultLabel.children[2].chartElement.options.font = `bold 15px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
      defaultLabel.children[2].chartElement.options.color = "#653193";
      return defaultLabel;
    } catch (error) {
      throw error;
    }
  }

  exportPdf(): void {
    drawDOM(document.getElementById("htmlData") as HTMLElement, {
      paperSize: "auto",
      scale: 0.9,
      landscape: true,
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },

    }).then((group: Group) => {
      return exportPDF(group);
    })
      .then((dataUri) => {
        saveAs(dataUri, "StrokeAlertChart.pdf");
      });
  }

  hideChartDiaglog(){
    this.piChartBool = false;
  }
  
  customSort(event: any) {
    let dateA:any;
    let dateB:any;
    if(this.field != event.multiSortMeta[0].field){
      this.isAscending = false;
    }
     this.field = event.multiSortMeta[0].field;
    
    if(this.field == 'date'){
      event.data.sort((a:any, b:any) => {
        dateA = new Date(a.date.replace(/\s+/g, ''));
        dateB = new Date(b.date.replace(/\s+/g, ''));
        if(this.isAscending){
        return dateB - dateA;
        }else{
        return dateA - dateB;
        }
      });
    }else{
    event.data.sort((data1: any, data2: any) => {
      let value1 = data1[this.field];
      let value2 = data2[this.field];
      let result = 0;
  
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2, undefined, {numeric: true});
      } else if (typeof value1 === 'number' && typeof value2 === 'number') {
        result = value1 - value2;
      } else if (typeof value1 === 'string' && typeof value2 === 'number') {
        result = 1;
      } else if (typeof value1 === 'number' && typeof value2 === 'string') {
        result = -1;
      }
      if (this.isAscending) { result = -result; }
      return result;
    });
  }
    this.isAscending = !this.isAscending;
  }
  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
     Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
     
     }
}